// extracted by mini-css-extract-plugin
export default {"container":"style_container__mEEPl","content":"style_content__rienV","descWrapper":"style_descWrapper__Jqk6i"};